import React from 'react';
import { componentService } from 'js/services/component.service';

export const PlayerAccountInfoReviewReminder = React.lazy(() => import(/* webpackChunkName: "player-account-info-review-reminder" */ './PlayerAccountInfoReviewReminder'));

componentService.registerPageComponents({ 'player-account-info-review-reminder': PlayerAccountInfoReviewReminder });
